import React from 'react';
/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  a,
  gs,
  BoxC,
  HtyC,
  IptC,
  LblC,
  SrlC,
  GridC,
  _cv_42___Ci,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as SrlC from "./_ccbSrlC";
import * as GridC from "./_cccGridC";
import * as HtyC from "./_ccmHtyC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as _cv_42___Ci from "./_cv_42___Ci";
import * as ht from './_ht';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  const _gUserz = gs.useUserz();

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a(`mb/2`),
          lineCs: [{
            cellCs: [
              {
                oClds: [
                ]
              },
              {
                oClds: [
                ]
              },
              {
                oClds: [
/*
                  cr.c(LblC.N, {
                    key: -10,
                    abtType: 'ftnCmnz',
                    boxStlz: a('dw/23'),
                    lblCz: {
                      boxStlz: a('dw/8'),
                      textz: {
                        pfx: '変更履歴',
                      }
                    },
                    cttCz: {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -10,
                          abtType: 'ftnCmnz',
                          cz: {
                            bEdit: true,
                            iptType: 'pcr',
                            ls: [],
                          },
                        })
                      ]
                    },
                  })
*/
                  cr.c(HtyC.N, {
                    key: -10,
                    sPz: pz.sPz,
                    cz: {
                      elm: '_42r',
                      cdn: `_42r_10r1k = ${pz.sPz.crt._10r_key}`
                    }
                  })

                ]
              }
            ]
          }]
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

            cr.c(SrlC.V, {
              key: -20,
              abtType: 'cttCmnz',
              oClds: [

                _gUserz.crt._31rz?._fst > 0 ?
                cr.c(_cv_42___Ci.D, {
                  key: -10,
                  sPz: pz.sPz,
                  cz: {
                    cdn: `_41r_31r1f=${_gUserz.crt._31rz?._fst}`
                  }
                })
                : undefined,

              ],
            }),

            cr.c(_cv_42___Ci.B, {
              key: -30,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                sc: 'gn7',
              }
            })

          ]
        })

      ]
    })
  );
};

